import countries from "i18n-iso-countries";
import pt from "i18n-iso-countries/langs/pt.json";

countries.registerLocale(pt);

const A = 0x1f1e6;

export function flagEmojiFromAlpha2(code) {
  if (!code || typeof code !== "string" || code.length !== 2) return "";
  const u = code.toUpperCase();
  if (u.length !== 2 || u[0] < "A" || u[0] > "Z" || u[1] < "A" || u[1] > "Z") return "";
  return String.fromCodePoint(A + u.charCodeAt(0) - 65, A + u.charCodeAt(1) - 65);
}

export function countryNamePt(code) {
  if (!code) return "";
  const n = countries.getName(code.toUpperCase(), "pt", { select: "official" });
  return n || code.toUpperCase();
}

export function allCountriesPtSorted() {
  const names = countries.getNames("pt", { select: "official" });
  return Object.keys(names)
    .filter((c) => c.length === 2)
    .map((code) => ({ code, name: names[code] }))
    .sort((a, b) => a.name.localeCompare(b.name, "pt"));
}

export function normalizeSearch(s) {
  return String(s || "")
    .normalize("NFD")
    .replace(/\p{M}/gu, "")
    .toLowerCase();
}
